import { render, staticRenderFns } from "./soNoInput.vue?vue&type=template&id=60b88188&"
import script from "./soNoInput.vue?vue&type=script&lang=js&"
export * from "./soNoInput.vue?vue&type=script&lang=js&"
import style0 from "./soNoInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60b88188')) {
      api.createRecord('60b88188', component.options)
    } else {
      api.reload('60b88188', component.options)
    }
    module.hot.accept("./soNoInput.vue?vue&type=template&id=60b88188&", function () {
      api.rerender('60b88188', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/soNoInput.vue"
export default component.exports